import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CompanyArrayModel, CompanyModel } from '../../models/CompanyModel';

const initialCompanyState: CompanyArrayModel = {
    all_Companies: [],
    particular_Company: {
        "companyId": 0,
        "name": "",
        "companyUserId": 0,
        "roleId": 0,
        "description": "",
        "isActive": false
    }
}
const CompanySlice = createSlice({
    name: 'Company',
    initialState: initialCompanyState,
    reducers: {
        setCompanies(state, action: PayloadAction<CompanyModel[]>) {
            state.all_Companies = action.payload;
        },
        setParticularCompany(state, action: PayloadAction<CompanyModel>) {
            state.particular_Company = action.payload;
        }
    }
})
export default CompanySlice;